import { render } from "./side-panel-calendar.vue?vue&type=template&id=677157b4&scoped=true"
import script from "./side-panel-calendar.vue?vue&type=script&lang=js"
export * from "./side-panel-calendar.vue?vue&type=script&lang=js"

import "./side-panel-calendar.vue?vue&type=style&index=0&id=677157b4&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677157b4"],['__file',"src/components/admin-dashboard/panels/side-panel-calendar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "677157b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('677157b4', __exports__)) {
    api.reload('677157b4', __exports__)
  }
  
  module.hot.accept("./side-panel-calendar.vue?vue&type=template&id=677157b4&scoped=true", () => {
    api.rerender('677157b4', render)
  })

}


export default __exports__